// extracted by mini-css-extract-plugin
export var activityContainer = "_ni-0";
export var typingIndicatorContainer = "_ni-1";
export var typingIndicatorDot = "_ni-2";
export var wave = "_ni-3";